import { render } from "./Login.vue?vue&type=template&id=0cb9767f&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=0cb9767f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb9767f"]])

export default __exports__